import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Skills Redux States
import {
  GET_SKILLS,
  GET_SKILL,
  CREATE_SKILL,
  EDIT_SKILL,
  DELETE_SKILL,
} from "./actionTypes";
import {
  setSkills,
  apiError,
  setSkill,
  createSkillSuccess,
  editSkillSuccess,
  deleteSkillSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getSkills({ payload: { page, qnt, name } }) {
  try {
    const response = yield call(
      axios.get,
      `/skill?filter=name${
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") 
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setSkills(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createSkill({ payload: { newSkillValues } }) {
  try {
    const response = yield call(axios.post, `/skill`, newSkillValues);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createSkillSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getSkill({ payload: { idSkill, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/skill?${
        (idSkill ? `id=${idSkill}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setSkill(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editSkill({ payload: { idSkill, newSkillValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/skill?${idSkill ? `id=${idSkill}` : ""}`,
      newSkillValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editSkillSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteSkill({ payload: { idSkill } }) {
  try {
    const response = yield call(
      axios.delete,
      `/skill${idSkill ? `?id=${idSkill}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteSkillSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchSkill() {
  yield takeEvery(GET_SKILLS, getSkills);
}
export function* watchGetSkill() {
  yield takeEvery(GET_SKILL, getSkill);
}
export function* watchCreateSkill() {
  yield takeEvery(CREATE_SKILL, createSkill);
}
export function* watchEditSkill() {
  yield takeEvery(EDIT_SKILL, editSkill);
}
export function* watchDeleteSkill() {
  yield takeEvery(DELETE_SKILL, deleteSkill);
}
function* authSaga() {
  yield all([
    fork(watchSkill),
    fork(watchGetSkill),
    fork(watchCreateSkill),
    fork(watchEditSkill),
    fork(watchDeleteSkill),
  ]);
}

export default authSaga;
